// ** React Imports
import { Suspense, lazy } from "react";

// ** Utils
// import { isUserLoggedIn } from "@utils";
import { useLayout } from "@hooks/useLayout";
// import { AbilityContext } from "@src/utility/context/Can";
import { useRouterTransition } from "@hooks/useRouterTransition";

// ** Custom Components
import LayoutWrapper from "@layouts/components/layout-wrapper";
// import history from "../constants/history";

// ** Router Components
import {
	BrowserRouter as AppRouter,
	Route,
	Switch,
	Redirect,
} from "react-router-dom";

// ** Routes & Default Routes
import {
	// DefaultRoute,
	Routes,
} from "./routes";

// ** Layouts
import BlankLayout from "@layouts/BlankLayout";
import VerticalLayout from "@src/layouts/VerticalLayout";
// import HorizontalLayout from "@src/layouts/HorizontalLayout";
import Login from "../ui/pages/SignIn";

// import withSession from "../ui/components/Session/withSession";

// import Footer from "../ui/components/Footer";
// import { useSelector } from "react-redux";

const Routers = (props) => {
	// ** Hooks
	const { layout, setLayout, setLastLayout } = useLayout();
	const { transition, setTransition } = useRouterTransition();

	// const { userData } = useSelector((state) => state?.auth);

	// ** Default Layout
	const DefaultLayout =
		layout === "horizontal" ? "HorizontalLayout" : "VerticalLayout";

	// ** All of the available layouts
	// const Layouts = { BlankLayout, VerticalLayout, HorizontalLayout };

	// ** Current Active Item
	const currentActiveItem = null;

	// const NotAuthorized = lazy(() => import("@src/ui/components/Error/NotAuthorized"));

	// ** Init Error Component
	const Error = lazy(() => import("@src/ui/components/Error/404"));

	const AdminRoute = ({ component: Component, ...rest }) => {
		const routerProps = {};

		return (
			<Route
				{...rest}
				render={(props) => {
					localStorage.setItem("currentModule", rest?.moduleName);
					let me = localStorage.getItem("token");
					let userRes = JSON.parse(localStorage.getItem("UserRes"));
					if (me) {
						if (
							props.match.path === "/cnf-wise" ||
							props.match.path === "/projections"
						) {
							if (
								userRes?.PROFILE_ID !== "HORPT" &&
								userRes?.PROFILE_ID !== "HOADM"
							) {
								return (
									<Redirect
										to={{
											pathname: "/",
											state: { from: props.location },
										}}
									/>
								);
							} else {
								return (
									<VerticalLayout
										layout={"VerticalLayout"}
										setLayout={setLayout}
										transition={transition}
										routerProps={routerProps}
										setLastLayout={setLastLayout}
										setTransition={setTransition}
										currentActiveItem={currentActiveItem}
									>
										<LayoutWrapper
											layout={DefaultLayout}
											transition={transition}
											setTransition={setTransition}
											{...(rest.appLayout
												? {
														appLayout:
															rest.appLayout,
												  }
												: {})}
											{...(rest.meta
												? {
														routeMeta: rest.meta,
												  }
												: {})}
											{...(rest.className
												? {
														wrapperClass:
															rest.className,
												  }
												: {})}
										>
											<Suspense fallback={null}>
												<Component
													{...props}
													{...rest}
												/>
											</Suspense>
										</LayoutWrapper>
									</VerticalLayout>
								);
							}
						} else {
							return (
								<VerticalLayout
									layout={"VerticalLayout"}
									setLayout={setLayout}
									transition={transition}
									routerProps={routerProps}
									setLastLayout={setLastLayout}
									setTransition={setTransition}
									currentActiveItem={currentActiveItem}
								>
									<LayoutWrapper
										layout={DefaultLayout}
										transition={transition}
										setTransition={setTransition}
										{...(rest.appLayout
											? {
													appLayout: rest.appLayout,
											  }
											: {})}
										{...(rest.meta
											? {
													routeMeta: rest.meta,
											  }
											: {})}
										{...(rest.className
											? {
													wrapperClass:
														rest.className,
											  }
											: {})}
									>
										<Suspense fallback={null}>
											<Component {...props} {...rest} />
										</Suspense>
									</LayoutWrapper>
								</VerticalLayout>
							);
						}
					} else {
						return (
							<Redirect
								to={{
									pathname: "/",
									state: { from: props.location },
								}}
							/>
						);
					}
				}}
			/>
		);
	};
	const PublicRoute = ({ component: Component, ...rest }) => {
		return (
			<Route
				{...rest}
				render={(props) => {
					const token = localStorage.getItem("token");
					if (token) {
						return (
							<Redirect
								to={{
									pathname: "/dashboard",
									state: { from: props.location },
								}}
							/>
						);
					} else {
						return (
							<BlankLayout>
								<Component {...props} {...rest} />
							</BlankLayout>
						);
					}
				}}
			/>
		);
	};

	// const { session, refetch } = props;
	return (
		<AppRouter>
			<Switch>
				{Routes.map((d, key) => {
					if (d.layout === "BlankLayout") {
						if (d.path === "/signin") {
							return (
								<PublicRoute
									key={key}
									exact
									path={d.path}
									{...d}
									component={() => <Login />}
								/>
							);
						} else {
							return (
								<PublicRoute
									key={key}
									exact
									path={d.path}
									{...d}
									component={d.component}
								/>
							);
						}
					} else {
						return (
							<AdminRoute
								key={key}
								exact
								path={d.path}
								{...d}
								component={d.component}
							/>
						);
					}
				})}
				<Route path="*" component={Error} />
			</Switch>
		</AppRouter>
	);
};

// export default withSession(Routers);
export default Routers;
